module.exports = __webpack_public_path__ + "img/6.a8d4c4c5.jpg";